import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Simran
 * id 8E3D93CC-DE0A-4828-AC9A-9A6CFD932978
 * name clipboard-pulse
 * version: 2.1.99
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/clipboard-pulse.svg
 * tags
 * - Medical / Hospital 
 */
export const ClipboardPulseIcon = createSvgIcon(<><path d="M19,3H14.82C14.4,1.84 13.3,1 12,1C10.7,1 9.6,1.84 9.18,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3M12,3A1,1 0 0,1 13,4A1,1 0 0,1 12,5A1,1 0 0,1 11,4A1,1 0 0,1 12,3M5,13.46H7.17L10.5,7.08L11.44,14.05L13.93,10.86L16.53,13.46H19V15H15.89L14.07,13.21L10.38,17.92L9.62,12.15L8.11,15H5V13.46Z" /></>, 'ClipboardPulseIcon');
export default ClipboardPulseIcon